import { TWorkflowView } from "@elixir/types";
import fetch from "../../fetch-client";
import { GET_TRYST_HOST } from "../../constants/env";
import { TrystGenericResponse } from "../../types/tryst";

type TPatchUpdateWorkflowView = {
  view_id: string;
  assignee_id: string;
  data: TWorkflowView;
};

export default async function patchUpdateWorkflowView({
  view_id,
  assignee_id,
  data,
}: TPatchUpdateWorkflowView): Promise<TrystGenericResponse<{}>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(data);

    const requestOptions: RequestInit = {
      method: "PATCH",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
      credentials: "include",
      mode: "cors",
    };

    const response = await fetch(
      `${TRYST_HOST}/workflow-view/${view_id}/assignee/${assignee_id}`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
